import React from "react";
import "../App.css";
import HeroSection from "../components/HeroSection/HeroSection";
import Cards from "../components/Cards/Cards";

function Home() {
  return (
    <>
      <HeroSection />
      <Cards />
    </>
  );
}

export default Home;
